// extracted by mini-css-extract-plugin
export var logo = "_l8-2";
export var logoWrapper = "_l8-1";
export var strip = "_l8-0";